<template>
  <div class="currentUserInfo">
    <h1>Retrieve from store: {{ currentUserName }}</h1>
    <p>Your email address is: {{ currentUserEmail }}</p>
    <p>Your Cognito ID is: {{ currentUserSub }}</p>
  </div>
</template>

<script>
//import { Auth } from "aws-amplify";

export default {
  name: "curentUser",
  computed: {
    //the following shows how to use store getters
    currentUserName() {
      return this.$store.getters.getCurrentUserName;
    },
    //the following just pulls the data from the store state
    currentUserEmail() {
      return this.$store.state.currentUser.currentUserEmail;
    },
    currentUserSub() {
      return this.$store.state.currentUser.currentUserSub;
    }
  }
};
</script>
